import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { enableMapSet } from 'immer';

import data_slice from './data/slice';
import type { RootState } from './types';

export type { RootState } from './types';

enableMapSet();

const rootReducer = combineReducers({
  data_slice,
});

function getSessionPreloadedState(): RootState | undefined {
  const preloadedStateJSON = sessionStorage.getItem('PRELOADED_STATE');
  return preloadedStateJSON
    ? (JSON.parse(preloadedStateJSON) as RootState)
    : undefined;
}

export function createAppStore(options?: {
  preloadedState?: Partial<RootState>;
  useSessionPreloadedState?: boolean;
}) {
  const preloadedState =
    options?.preloadedState ??
    (options?.useSessionPreloadedState === false
      ? undefined
      : getSessionPreloadedState());

  return configureStore({
    reducer: rootReducer,
    preloadedState: preloadedState as RootState | undefined,
  });
}

const store = createAppStore();

export type AppDispatch = typeof store.dispatch;

export default store;
